import type { UploadDestination } from "@/types/FileUploadCounts";

/** Upload ownership is captured at selection, never inferred from whichever route is open later. */
export function uploadBelongsToEntity(
	destination: UploadDestination | undefined,
	entityType: string | null,
	entityId: string,
	projectConversationIds: readonly string[] = []
): boolean {
	if (!destination?.conversationId || !entityId) return false;
	if (entityType === "conversation") return destination.conversationId === entityId;
	return entityType === "project" && (destination.projectId === entityId || projectConversationIds.includes(destination.conversationId));
}
